












































import { CreateReportAsPartnerDto, getCreateReportDto } from "@/lib/dto/create-report-as-partner-dto";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ActivityLog } from "@/models/activity-log.entity";
import { IReport, Report } from "@/models/report.entity";
import {
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivCreateReportAsPartnerDtoGen,
  MrfiktivReferenceGen,
  MrfiktivUpdateReportDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { DamageAreaEnum } from "@/store/enum/damage-area.enum";
import { ReportType } from "@/store/enum/reportType";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import CreateReportForm from "../fleet/CreateReportForm.vue";
import Card from "../utility/Card.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import DateTimePicker from "../utility/DateTimePicker.vue";
import Tooltip from "../utility/tooltip.vue";
import PartnerReportCardAccidentDetails from "./PartnerReportCardAccidentDetails.vue";
import PartnerReportCardAddress from "./PartnerReportCardAddress.vue";
import PartnerReportCardContact from "./PartnerReportCardContact.vue";
import PartnerReportCardDamage from "./PartnerReportCardDamage.vue";
import PartnerReportCardDatePreference from "./PartnerReportCardDatePreference.vue";
import PartnerReportCardGeneral from "./PartnerReportCardGeneral.vue";

export enum ReportUpdateTabEnum {
  /**
   * Show only position selector in report tab
   */
  position = "position",

  /**
   * Show entire report tab (position info, report type, title, external id)
   */
  report = "report",
  accident = "accident",
  witness = "witness",
  police = "police",
  preExisting = "preExisting",
  body = "body",
  message = "message",
  contact = "contact",
  leasing = "leasing",
  images = "images",
  insurance = "insurance",
  broker = "broker"
}

@Component({
  components: {
    ConfirmActionDialog,
    DateTimePicker,
    Card,
    Tooltip,
    LatestEntriesCardEmpty,
    PartnerReportCardGeneral,
    PartnerReportCardAddress,
    PartnerReportCardContact,
    PartnerReportCardDatePreference,
    PartnerReportCardDamage,
    PartnerReportCardAccidentDetails,
    CreateReportForm
  }
})
export default class PartnerReportUpdateReportDialog extends mixins(PermissionMixin) {
  @Prop()
  config!: ReportUpdateTabEnum[];

  @Prop({ default: "report" })
  activityTarget?: string;

  @Prop({ default: false })
  fullscreen!: boolean;

  @Prop({ default: 1000 })
  width!: number;

  @Prop({ default: false })
  hideButton?: boolean;

  isDialogActive = false;

  updateLoading = false;

  updateReportDto: MrfiktivUpdateReportDtoGen = {};

  isValid = true;

  get isImages() {
    return this.config.includes(ReportUpdateTabEnum.images);
  }

  get isPreExisting() {
    return this.config.includes(ReportUpdateTabEnum.preExisting);
  }

  get isInsurance() {
    return this.config.includes(ReportUpdateTabEnum.insurance);
  }

  get isBroker() {
    return this.config.includes(ReportUpdateTabEnum.broker);
  }

  get isPosition() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.position)) {
      return false;
    }

    return true;
  }

  get isReport() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.report)) {
      return false;
    }

    return true;
  }
  get isAccidentDetails() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.accident)) {
      return false;
    }

    return true;
  }
  get isWitness() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.witness)) {
      return false;
    }

    return true;
  }
  get isPoliceDetails() {
    if (!this.config.includes(ReportUpdateTabEnum.police)) {
      return false;
    }

    return true;
  }

  get isLeasingDetails() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.leasing)) {
      return false;
    }

    return true;
  }

  get isBody() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.body)) {
      return false;
    }

    if (this.report.body) {
      return true;
    }

    return true;
  }
  get isMessage() {
    if (!this.config.includes(ReportUpdateTabEnum.message)) {
      return false;
    }

    return true;
  }
  get isContact() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.contact)) {
      return false;
    }

    return true;
  }

  get isExternalId() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (this.report.externalId) {
      return true;
    }

    return false;
  }

  get report() {
    return PartnerModule.report;
  }

  get accidentDetailsDate() {
    if (!this.updateReportDto.accidentDetails) {
      return new Date();
    }
    return new Date(this.updateReportDto.accidentDetails.date);
  }

  set accidentDetailsDate(date: Date) {
    if (!this.updateReportDto.accidentDetails) {
      return;
    }
    this.updateReportDto.accidentDetails.date = date.toISOString();
  }

  mapReportToUpdateDto(report: IReport): MrfiktivUpdateReportDtoGen {
    return Report.mapReportToUpdateDto(report, {
      isBroker: this.isBroker,
      isInsurance: this.isInsurance,
      isLeasingDetails: this.isLeasingDetails,
      isWitness: this.isWitness,
      isPoliceDetails: this.isPoliceDetails,
      isAccidentDetails: this.isAccidentDetails,
      isContact: this.isContact,
      isImages: this.isImages,
      isReport: this.isReport,
      isPosition: this.isPosition
    });
  }

  startDialog() {
    this.updateReportDto = this.mapReportToUpdateDto(this.report);

    this.isDialogActive = true;
  }

  show() {
    this.startDialog();
  }

  async update() {
    try {
      const partnerId = this.report.partnerId;
      const reportId = this.report._id;
      this.updateLoading = true;
      const createDto: MrfiktivCreateReportAsPartnerDtoGen = getCreateReportDto({
        ...this.updateReportDto,
        damage: this.updateReportDto.damage as DamageAreaEnum[],
        reportType: this.updateReportDto.reportType as ReportType
      } as CreateReportAsPartnerDto);

      // Fix for issue where create DTO expects wittness, update dto expects witness.
      const witness = createDto.wittness;
      createDto.wittness = undefined;
      const updateDto = {
        ...createDto,
        witness
      };

      await PartnerModule.report.updatePartial(updateDto);
      this.isDialogActive = false;

      const source: MrfiktivReferenceGen = {
        refType: BackendResourceEnum.REPORT,
        refId: reportId
      };
      const data: MrfiktivCreateActivityLogDtoGen = {
        source,
        actionType: ActionEnum.UPDATE,
        comment: this.activityTarget,
        isDeletable: true,
        activity: ActivityTypeEnum.UPDATE_REPORT
      };

      await new ActivityLog({
        partnerId,
        ...data
      })
        .create()
        .catch(handleError);
    } catch (e) {
      handleError(e);
    } finally {
      this.updateLoading = false;
    }
  }
}
